globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.LocalManagement = appCustomerSpace.Modals.LocalManagement || {};

appCustomerSpace.Modals.LocalManagement.GenerateLongDescription = (function (superClass) {

  utils.extend(GenerateLongDescription, superClass);

  function GenerateLongDescription() {
    return GenerateLongDescription.__super__.constructor.apply(this, arguments);
  }

  $.extend(GenerateLongDescription.prototype, {
    init: function () {
      var modal = this;

      modal.$generateBtn = modal.$html.find('#ai-generate-btn');
      modal.$applyBtn = modal.$html.find('#ai-apply-btn');
      modal.$briefingTextarea = modal.$html.find('#ai-briefing-textarea');
      modal.$resultTextarea = modal.$html.find('#ai-result-textarea');

      modal.$generateBtn.on('click', function () {
        modal.generateDescription();
      });

      modal.$applyBtn.on('click', function () {
        modal.applyDescription();
      });

      return GenerateLongDescription.__super__.init.apply(this, arguments);
    },

    generateDescription: function () {
      var modal = this;
      var briefing = modal.$briefingTextarea.val();
      var url = modal.$generateBtn.data('generate-url');
      var $container = modal.$html.find('.modal-content');

      appCustomerSpace.Loader().start({ $container: $container, options: { text: false, icon_size: '3x' } });

      $.ajax({
        url: url,
        method: 'POST',
        data: { ai_generated_long_description_briefing: briefing },
        dataType: 'json',
        success: function (data) {
          appCustomerSpace.Loader().stop({ $container: $container });
          if (data.response === 1) {
            modal.$resultTextarea.val(data.ai_generated_long_description);
            modal.$resultTextarea.prop('disabled', false);
            modal.$applyBtn.prop('disabled', false);
            modal.$applyBtn.removeClass('btn-default');
            modal.$applyBtn.addClass('btn-primary');
            modal.$html.find('#ai-disclaimer').removeClass('hidden');
            modal.$generateBtn.removeClass('btn-primary');
            modal.$generateBtn.addClass('btn-default');
          } else {
            new PNotify({ icon: 'icon-cross2', title: data.error || 'Une erreur est survenue', type: 'error', delay: 3000 });
          }
        },
        error: function () {
          appCustomerSpace.Loader().stop({ $container: $container });
          new PNotify({ icon: 'icon-cross2', title: 'Une erreur est survenue', type: 'error', delay: 3000 });
        }
      });
    },

    applyDescription: function () {
      var modal = this;
      var url = modal.$applyBtn.data('apply-url');
      var $container = modal.$html.find('.modal-content');

      appCustomerSpace.Loader().start({ $container: $container, options: { text: false, icon_size: '3x' } });

      $.ajax({
        url: url,
        method: 'POST',
        dataType: 'json',
        success: function (data) {
          appCustomerSpace.Loader().stop({ $container: $container });
          if (data.response === 1) {
            modal.close();
            window.location.reload();
          } else {
            new PNotify({ icon: 'icon-cross2', title: data.error || 'Une erreur est survenue', type: 'error', delay: 3000 });
          }
        },
        error: function () {
          appCustomerSpace.Loader().stop({ $container: $container });
          new PNotify({ icon: 'icon-cross2', title: 'Une erreur est survenue', type: 'error', delay: 3000 });
        }
      });
    }
  });

  return GenerateLongDescription;

})(appCustomerSpace.Modal);
